import React from 'react';
import { FaFileExcel, FaDownload } from 'react-icons/fa';

const DownloadExcel = () => {
  const templates = [
    { name: 'Template 1', file: '/Template1.xlsx' },
    { name: 'Template 2', file: '/Template2.xlsx' }
  ];

  const buttonStyle = {
    backgroundColor: 'white',
    color: '#991b1b',
    padding: '10px 16px',
    borderRadius: '6px',
    border: '1.5px solid #b91c1c',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontWeight: '500',
    fontSize: '15px',
    width: 'fit-content',
    cursor: 'pointer',
    marginBottom: '10px',
    marginRight: "15px",
    transition: 'all 0.2s ease'
  };

  const templateStyle = {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '16px',
  };

  return (
    <div >
      <span style={{ fontSize: '17px', fontWeight: '600' , marginTop: '16px',}}>
        Available Templates
      </span>

      <div style={templateStyle}>
        {templates.map((template, index) => (
          <a
            key={index}
            href={template.file}
            download
            style={buttonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#fff5f5';
              e.currentTarget.style.borderColor = '#991b1b';
              e.currentTarget.style.color = '#7f1d1d';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.borderColor = '#b91c1c';
              e.currentTarget.style.color = '#991b1b';
            }}
          >
            <FaFileExcel size={18} color="#b91c1c" />
            {template.name}
            <FaDownload size={16} color="#b91c1c" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default DownloadExcel;
